import { render, staticRenderFns } from "./UnitsTabPositions.vue?vue&type=template&id=648963d8"
import script from "./UnitsTabPositions.vue?vue&type=script&lang=js"
export * from "./UnitsTabPositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports